import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from '../constant/api-url';
import { attachApiTelemetry } from '../telemetry/http';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: () => true,
});

// The bearer token for every request. It is module state so the interceptor below is
// registered exactly once; the old setTokenInterceptor added a new one on every call.
let accessToken = '';

api.interceptors.request.use((config) => {
  const requestConfig = config;
  if (accessToken) {
    requestConfig.headers.Authorization = `Bearer ${accessToken}`;
  }
  return requestConfig;
});

attachApiTelemetry(api);

// Same signature as before, so the hooks that call `await setToken(token)` are untouched.
const setToken = async (token: string): Promise<AxiosInstance> => {
  accessToken = token;
  return api;
};

export default setToken;
